import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { HallsActionTypes } from "../actions/actionTypes";
import { hallsAPI } from "../api/api";
import { historyAPI } from "../../history/api/api";
import { configurationsAPI } from "../../configurations/api/api";

function* getCompareConfigurations(action) {
    try {
        const request = yield call(() =>
            hallsAPI.getCompareConfigurations({ confIds: action.payload.confIds })
        );

        let configurations = request.data.results

        const hall = yield call(() =>
            historyAPI.getActivityLogs(dataToSendHistory("Hall",action.payload.hall.id, "ADD"))
        );
        const historyHallResp = yield call(() =>
            historyAPI.getActivityLogs(dataToSendHistory("Hall",action.payload.hall.id, "EDIT"))
        );

        const historyServerResp = yield call(() =>
            historyAPI.getActivityLogs(dataToSendHistory("Server",action.payload.server.id, "EDIT"))
        );

        let configIds = configurations.map(config => { return config.id })

        const historyConfigResp = yield call(() =>
            historyAPI.getActivityLogs(dataToSendHistory("Configuration",configIds, "ADD"))
        );

        const configsHistory = getConfigHistory(historyConfigResp.data.results)

        const server = yield call(() =>
            configurationsAPI.getServer({ serverId: action.payload.server.id })
        );

        let historyResponse = historyHallResp.data.results

        historyServerResp.data.results.map(item => historyResponse.push(item))

        if(historyResponse.length > 0){

            historyResponse.reverse();
            let history = {
                name: getHistory(historyResponse, hall.data.results[0], 'name', "Hall"),
                address1: getHistory(historyResponse, hall.data.results[0], 'address_line_1', "Hall"),
                address2: getHistory(historyResponse, hall.data.results[0], 'address_line_2', "Hall"),
                server: getHistory(historyResponse, historyServerResp.data.results[0], 'name', "Server"),
            };
            configurations.map(config => {
                try {
                    const configHistory = configsHistory.find(item => item.id === config.id);

                    const dateCreated = configHistory
                        ? configHistory.date.replace(/\.\d+/, "")
                        : config.created_on.replace(/\.\d+/, "");

                    config.settings.settings_hall = {
                        hall_name: history.name.length > 0
                            ? getValueByKey(history, "name", dateCreated)
                            : action.payload.hall.name,
                        address1: history.address1.length > 0
                            ? getValueByKey(history, "address1", dateCreated)
                            : action.payload.hall.address_line_1,
                        address2: history.address2.length > 0
                            ? getValueByKey(history, "address2", dateCreated)
                            : action.payload.hall.address_line_2,
                        server_name: history.server.length > 0
                            ? getValueByKey(history, "server", dateCreated)
                            : server.data.name,
                    }
                } catch (error) {
                    console.error(error);
                }
            });
        } else {
            configurations.map(config => {
                config.settings.settings_hall = {
                    hall_name : action.payload.hall.name,
                    address1: action.payload.hall.address_line_1,
                    address2: action.payload.hall.address_line_2,
                    server_name: server.data.name
                }
            });
        }
        yield all({
            hallList: put({
                type: HallsActionTypes.GET_COMPARE_CONFIGURATIONS_SUCCESS,
                payload: {
                    configurations: configurations
                }
            })
        });
    } catch (e) {
        API.handleError(e.response, "Error getting configurations to compare.");

        yield put({
            type: HallsActionTypes.GET_COMPARE_CONFIGURATIONS_FAIL,
            message: e.message
        });
    }
}

const dataToSendHistory = (type, id, event) => {
    return {
        skip: 0,
        top: null,
        event: event,
        users: [],
        range: {},
        entity_type: type,
        entity_id: id
    }
}

const getHistory = (historyResponse, data, key, entity) => {
    const changes = []
    historyResponse.map(history => {
        if(history.entity_type === entity && history.additional_info.changes.find(change => change.field === key))
            changes.push(history)
    });
    let history = []
    changes.map((item, index) => {
        const change = item.additional_info.changes.find(change => change.field === key);
        if (index === 0 && data) {
            history.push({
                initial: data.event_time.replace(/\.\d+/, ""),
                end: item.event_time.replace(/\.\d+/, ""),
                name: change.old_value
            });
        }
        const currentDate = new Date();
        let date;
        if(changes.length - 1 > index) {
            date = new Date(changes[index + 1].event_time);
            date.setSeconds(date.getSeconds() + 60);
        }

        history.push({
            initial: item.event_time.replace(/\.\d+/, ""),
            end: changes.length - 1 === index ? currentDate.toISOString().replace(/\.\d+/, "") : date.toISOString().replace(/\.\d+/, ""),
            name: change.new_value
        });
    });
    return history
}

const getConfigHistory = (historyResponse) =>{
    const changes = []
    historyResponse.map(history => {
        changes.push({
            id: history.entity_id,
            date: history.event_time.replace(/\.\d+/, ""),
        });
    })
    return changes
};

const getValueByKey = (history, key, date) => {
    let name ;
    history[key].map(item => {
        if(date >= item.initial && date < item.end) {
            name = item.name
        }
    })
    return name
}

export function* getCompareConfigurationsWatcher() {
    yield takeLatest(
        HallsActionTypes.GET_COMPARE_CONFIGURATIONS,
        getCompareConfigurations
    );
}
